/* unplugin-vue-components disabled */import script from "./detailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsView.vue?vue&type=script&setup=true&lang=js"

import "./detailsView.vue?vue&type=style&index=0&id=506acbc3&lang=scss"

const __exports__ = script;

export default __exports__